import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  commandType: null,     // Örn: "drawLine", "move"
  step: 0,               // Komutun kaçıncı adımında olduğumuzu tutar
  data: {},              // Komuta özel geçici veriler (örnek: startPoint)
  lastCommandType: null, // 🆕 yeni alan
  message: "", // 👈 yeni alan
  undoRedoCommand: 'NONE', // 🔄 Undo/Redo hook sistemi: 'NONE' | 'UNDO' | 'REDO'
  drawMethod: null,  // null = default yontem
  textOptions: {
    font: "Arial",
    fontSize: "12",
    alignment: "left",
  },
};

const operationSlice = createSlice({
  name: 'operation',
  initialState,
  reducers: {
    setCommandType: (state, action) => {
      // Idempotent: aynı commandType tekrar set edilirse state'i değiştirme →
      // gereksiz re-render/dispatch döngüsünü kes.
      if (state.commandType === action.payload) return;
      state.lastCommandType = action.payload; // 🧠 son komutu kaydet
      state.commandType = action.payload;
      state.step = 0;
      state.data = {};
      // targetPanelId sıfırlanmaz - setOperationData ile set edilir

    },
    setOperationStep: (state, action) => {
      state.step = action.payload;
    },
    setOperationData: (state, action) => {
      state.data = { ...state.data, ...action.payload };
    },
    setCommandMessage: (state, action) => {
      // Idempotent: aynı mesaj tekrar yazılırsa state ref'i değiştirme.
      // useComponentWiring effect'i her aktivasyonda aynı sabit mesajı dispatch
      // ediyordu; bu guard, olası re-render cascade'ini kesin durdurur.
      if (state.message === action.payload) return;
      state.message = action.payload;
    },
    setDrawMethod(state, action) {
      state.drawMethod = action.payload;
    },
    resetOperation: (state) => {
      state.commandType = null;
      state.step = 0;
      state.data = {};
      state.message = "";
      state.drawMethod = null;
      // 🔥 lastCommandType asla sıfırlanmaz
    },

    setTextOptions: (state, action) => {
      state.textOptions = action.payload;
    },

    setUndoRedoCommand: (state, action) => {
      state.undoRedoCommand = action.payload; // 'NONE' | 'UNDO' | 'REDO'
    }
  },
});

export const {
  setCommandType,
  setOperationStep,
  setOperationData,
  resetOperation,
  setCommandMessage,
  setDrawMethod,
  setTextOptions,
  setUndoRedoCommand
} = operationSlice.actions;

export default operationSlice.reducer;
